__turbopack_context__.v({
  "accordionSlideOverwrite": "demoButton-module-scss-module__lP5fBq__accordionSlideOverwrite",
  "demoButton": "demoButton-module-scss-module__lP5fBq__demoButton",
  "demoButtonWithEndIcon": "demoButton-module-scss-module__lP5fBq__demoButtonWithEndIcon",
  "endIconBubble": "demoButton-module-scss-module__lP5fBq__endIconBubble",
  "fadeIn": "demoButton-module-scss-module__lP5fBq__fadeIn",
  "fadeOut": "demoButton-module-scss-module__lP5fBq__fadeOut",
  "scaleIn": "demoButton-module-scss-module__lP5fBq__scaleIn",
  "scaleOut": "demoButton-module-scss-module__lP5fBq__scaleOut",
  "zoomIn": "demoButton-module-scss-module__lP5fBq__zoomIn",
  "zoomOut": "demoButton-module-scss-module__lP5fBq__zoomOut",
});
